/**
 * <jharokha-frame> custom element.
 *
 * ResizeObserver sizes three nested <svg> viewports inside one parent SVG.
 * Caps: preserveAspectRatio="meet" — fixed geometry, deep scallops intact.
 * Mid:  preserveAspectRatio="none" — horizontal stretch only.
 * Math.round on cap width ensures pixel-exact viewport boundaries.
 */
class JharokhaFrame extends HTMLElement {
  /** Cap viewBox width / height */
  static CAP_RATIO = 260 / 538.78;

  connectedCallback() {
    this._ro = new ResizeObserver(() => this._layout());
    this._ro.observe(this);
    requestAnimationFrame(() => this._layout());
  }

  disconnectedCallback() {
    this._ro?.disconnect();
  }

  _layout() {
    const h = this.clientHeight;
    const w = this.clientWidth;
    if (!h || !w) return;

    // Round to pixel boundary — eliminates sub-pixel seams
    const capW = Math.round(h * JharokhaFrame.CAP_RATIO);
    const midW = Math.max(0, w - 2 * capW);

    const left = this.querySelector('[data-jh="left"]');
    const mid = this.querySelector('[data-jh="mid"]');
    const right = this.querySelector('[data-jh="right"]');

    // Define a 1-pixel overlap to kill the anti-aliasing seam
    const overlap = 1;

    if (left) {
      left.setAttribute('x', '0');
      left.setAttribute('y', '0');
      left.setAttribute('width', `${capW}`);
      left.setAttribute('height', `${h}`);
    }

    if (mid) {
      // Pull the middle section to the left by 1 pixel so it slides under the left cap
      mid.setAttribute('x', `${capW - overlap}`);
      mid.setAttribute('y', '0');

      // Increase the width to compensate for the left pull AND extend 1px to the right
      mid.setAttribute('width', `${midW + (overlap * 2)}`);
      mid.setAttribute('height', `${h}`);
    }

    if (right) {
      // Keep the right cap exactly where it was
      right.setAttribute('x', `${capW + midW}`);
      right.setAttribute('y', '0');
      right.setAttribute('width', `${capW}`);
      right.setAttribute('height', `${h}`);
    }
  }
}

if (!customElements.get('jharokha-frame')) {
  customElements.define('jharokha-frame', JharokhaFrame);
}
